import { RomaniaMaxPriceWrappedCalculationSettingsResponse } from 'com.cogvio.pricemonitor.api';
import { apiClientMutator } from '~/infrastructure/config/mutator';

export function resetRoMaxPriceList(userId: string, groupId: string) {
	const fetchData = async () => {
		const data = await apiClientMutator<RomaniaMaxPriceWrappedCalculationSettingsResponse>({
			url: `/users/${userId}/product-groups/${groupId}/ro-max-price/reset`,
			method: 'post',
		});
		return data;
	};
	return fetchData();
}
